import {handleLogout} from "components/utils"; import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import axios from "axios";
import 'react-vertical-timeline-component/style.min.css';
import {DiagnosticsVisitView} from "../../../diagnostics/DiagnosticsVisitView";

export const AddRecordView = (props: { cookieEntityQr: string, caseId: string, caseNumber: string, uhid: string, postAction: any, category: any, assignedDr: string }) => {


    const [successMessage, setSuccessMessage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [services, setServices] = useState<Array<any>>();
    const [visitId, setVisitId] = useState(null);

    let componentRef = useRef(null);

    function fetchServices() {
        axios.get('/api/backend/inventory/item/fetch/all/' + props.cookieEntityQr + "?type=SERVICE")
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                setServices(resp.data)
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
            })
    }

    useEffect(() => {

        if (props.cookieEntityQr) {
            fetchServices();
        }

    }, [props.cookieEntityQr])

    const handleSubmit = (e) => {
        if (e) {
            e.preventDefault()
        }
        componentRef.current.handleAddRecord(props.uhid, props.caseId)
        setSuccessMessage("")
        setErrorMessage("")
    };


    async function createAuditItem() {
        const resp = await axios.post('/api/backend/ipd/case/audit/create/', {
            entityQr: props.cookieEntityQr,
            caseId: props.caseId,
            medicalRecordId: null,
            itemId: null,
            type: "SERVICE"
        })
        console.log(resp.data)
        setVisitId(resp.data)
        return resp.data;
    }

    function getAddNewWidget() {
        return <>
            <DiagnosticsVisitView uhid={props.uhid} visitId={visitId} entityQr={props.cookieEntityQr} source={"IPD"}
                                  diagnosticCategory={props.category} shouldAddNew={true} createVisit={createAuditItem}/>
            {errorMessage &&
                <div className="text-danger fs-6">*{errorMessage}</div>
            }
        </>;
    }

    return (
        <>
            {getAddNewWidget()}
        </>
    );
}